import { match } from './filter-actions.match';
export var exec = function (groups, filters) {
    if (groups === void 0) { groups = []; }
    if (filters === void 0) { filters = []; }
    var filteredGroups = [];
    for (var _i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
        var group = groups_1[_i];
        if (match(group, filters)) {
            filteredGroups.push(group);
        }
    }
    return filteredGroups;
};
